import React from 'react';
import PropTypes from 'prop-types';
import Header from './header';
import LivingSlide from './livingSlide';
import errorBoundary from '@ifeng-fe/errorBoundary';
import HiddenSeoTime from '../../../common/seoUpdateTime';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    /**
     * 渲染网页布局
     */
    render() {
        const { content } = this.props;
        const { docData, slideData, footer, recommendData, interact } = content;

        return (
            <div>
                <HiddenSeoTime showHiddenPublish publishTime={docData.publishTime} updateTime={docData.updateTime} />
                <Header docData={docData} interact={interact} />
                <LivingSlide slideData={slideData} docData={docData} footer={footer} recommendData={recommendData} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
